export default __webpack_public_path__ + "static/media/020_start.last.35b20701.png";